/* JMBD Theme JS */

// ---------------------------------------------------------------------------
// Mobile nav toggle
// ---------------------------------------------------------------------------
const navToggle = document.querySelector('.nav-toggle');
const siteNav = document.querySelector('.site-nav');
if (navToggle && siteNav) {
  navToggle.addEventListener('click', () => {
    const open = siteNav.classList.toggle('open');
    navToggle.setAttribute('aria-expanded', open);
  });
}

// ---------------------------------------------------------------------------
// Product page: thumbnail switcher
// ---------------------------------------------------------------------------
const thumbs = document.querySelectorAll('.product-thumb');
const mainImage = document.getElementById('product-main-image');
thumbs.forEach(thumb => {
  thumb.addEventListener('click', () => {
    if (mainImage) mainImage.src = thumb.dataset.src;
    thumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// ---------------------------------------------------------------------------
// Product page: REAL variant selection
//
// Shopify's /cart/add only accepts a variant `id`. The option radios are for
// the shopper; this code translates the chosen options into the matching
// variant ID and writes it into the hidden `id` field before submit.
// ---------------------------------------------------------------------------
(function variantPicker() {
  const dataEl = document.getElementById('product-variants-json');
  const form = document.getElementById('product-form');
  const idField = document.getElementById('variant-id');
  if (!dataEl || !form || !idField) return;

  let variants = [];
  try {
    variants = JSON.parse(dataEl.textContent) || [];
  } catch (e) {
    return; // leave the default variant in place rather than break the page
  }
  if (!variants.length) return;

  const priceEl = document.getElementById('product-price');
  const addBtn = document.getElementById('add-to-cart');
  const radios = form.querySelectorAll('input[data-option-position]');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function selectedOptions() {
    const values = [];
    radios.forEach(r => {
      if (r.checked) values[parseInt(r.dataset.optionPosition, 10) - 1] = r.value;
    });
    return values;
  }

  function findVariant(values) {
    return variants.find(v =>
      values.every((val, i) => val === undefined || v.options[i] === val)
    );
  }

  function markUnavailable() {
    const chosen = selectedOptions();
    radios.forEach(r => {
      const pos = parseInt(r.dataset.optionPosition, 10) - 1;
      const probe = chosen.slice();
      probe[pos] = r.value;
      const match = variants.find(v => probe.every((val, i) => val === undefined || v.options[i] === val));
      const ok = !!(match && match.available);
      r.closest('.option-swatch')?.classList.toggle('unavailable', !ok);
    });
  }

  function update() {
    const variant = findVariant(selectedOptions());

    if (!variant) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
      markUnavailable();
      return;
    }

    idField.value = variant.id;
    if (window.JMBD && window.JMBD.product) {
      window.JMBD.product.variantId = variant.id;
      window.JMBD.product.price = variant.price / 100;
      window.JMBD.product.sku = variant.sku;
    }
    if (priceEl) priceEl.textContent = money(variant.price);
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    if (variant.featured_image && variant.featured_image.src && mainImage) {
      mainImage.src = variant.featured_image.src;
    }

    // Keep the URL shareable and back-button friendly.
    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    markUnavailable();
  }

  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      const label = radio.closest('.option-swatch');
      if (label) {
        label.closest('.option-values')
          .querySelectorAll('.option-swatch')
          .forEach(s => s.classList.remove('selected'));
        label.classList.add('selected');
      }
      update();
    });
  });

  // Honour ?variant= on load so shared links land on the right option set.
  const requested = new URLSearchParams(window.location.search).get('variant');
  if (requested) {
    const v = variants.find(x => String(x.id) === String(requested));
    if (v) {
      radios.forEach(r => {
        const pos = parseInt(r.dataset.optionPosition, 10) - 1;
        const isMatch = v.options[pos] === r.value;
        r.checked = isMatch;
        r.closest('.option-swatch')?.classList.toggle('selected', isMatch);
      });
    }
  }
  update();

  // Meta Pixel: AddToCart
  form.addEventListener('submit', function (e) {
    if (typeof fbq !== 'function') return;
    const qty = parseInt(form.querySelector('.qty-input')?.value || '1', 10);
    const p = (window.JMBD && window.JMBD.product) || {};
    e.preventDefault();
    try {
      fbq('track', 'AddToCart', {
        content_ids: [String(idField.value)],
        content_name: p.title,
        content_type: 'product',
        contents: [{ id: String(idField.value), quantity: qty }],
        value: (p.price || 0) * qty,
        currency: p.currency || 'USD'
      });
    } catch (err) { /* never block the sale on a tracking error */ }
    setTimeout(() => form.submit(), 200);
  });
})();

// ---------------------------------------------------------------------------
// Quantity buttons
// ---------------------------------------------------------------------------
document.querySelectorAll('.product-actions, .cart-item').forEach(ctx => {
  const minus = ctx.querySelector('.qty-minus');
  const plus = ctx.querySelector('.qty-plus');
  const input = ctx.querySelector('.qty-input');
  if (!input) return;
  minus?.addEventListener('click', () => {
    const v = parseInt(input.value, 10);
    if (v > 1) input.value = v - 1;
  });
  plus?.addEventListener('click', () => {
    input.value = parseInt(input.value, 10) + 1;
  });
});

// ---------------------------------------------------------------------------
// Cart: live quantity update + Meta Pixel InitiateCheckout
// ---------------------------------------------------------------------------
const cartForm = document.querySelector('form[action="/cart"]');
if (cartForm) {
  cartForm.querySelectorAll('.cart-qty-input').forEach(input => {
    input.addEventListener('change', () => cartForm.submit());
  });

  const checkoutBtn = cartForm.querySelector('button[name="checkout"]');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      if (typeof fbq !== 'function' || !window.JMBD || !window.JMBD.cart) return;
      e.preventDefault();
      try {
        fbq('track', 'InitiateCheckout', {
          content_ids: window.JMBD.cart.ids.map(String),
          contents: window.JMBD.cart.contents,
          content_type: 'product',
          num_items: window.JMBD.cart.itemCount,
          value: window.JMBD.cart.total,
          currency: window.JMBD.cart.currency
        });
      } catch (err) { /* never block checkout on a tracking error */ }
      setTimeout(() => {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'checkout';
        hidden.value = '';
        cartForm.appendChild(hidden);
        cartForm.submit();
      }, 200);
    });
  }
}

// ---------------------------------------------------------------------------
// Scroll-based header shadow
// ---------------------------------------------------------------------------
const header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', () => {
    header.style.boxShadow = window.scrollY > 8
      ? '0 2px 24px rgba(0,0,0,0.5)'
      : 'none';
  }, { passive: true });
}

// ---------------------------------------------------------------------------
// Size guide toggle
// ---------------------------------------------------------------------------
const sizeGuideBtn = document.querySelector('.size-guide-btn');
const sizeGuideTable = document.querySelector('.size-guide-table');
if (sizeGuideBtn && sizeGuideTable) {
  sizeGuideBtn.addEventListener('click', () => {
    const open = sizeGuideTable.hasAttribute('hidden');
    if (open) {
      sizeGuideTable.removeAttribute('hidden');
      sizeGuideBtn.setAttribute('aria-expanded', 'true');
      sizeGuideBtn.textContent = 'Size Guide −';
    } else {
      sizeGuideTable.setAttribute('hidden', '');
      sizeGuideBtn.setAttribute('aria-expanded', 'false');
      sizeGuideBtn.textContent = 'Size Guide +';
    }
  });
}
